export const RELIGION_LOADING = "RELIGION_LOADING";
export const GET_RELIGION = "GET_RELIGION";
export const GET_RELIGION_SUCCESS = "GET_RELIGION_SUCCESS";
export const GET_RELIGION_FAIL = "GET_RELIGION_FAIL";
export const DELETE_RELIGION = "DELETE_RELIGION"
export const DELETE_RELIGION_SUCCESS = "DELETE_RELIGION_SUCCESS"
export const DELETE_RELIGION_FAIL = "DELETE_RELIGION_FAIL"
export const UPDATE_RELIGION = "UPDATE_RELIGION"
export const UPDATE_RELIGION_SUCCESS = "UPDATE_RELIGION_SUCCESS"
export const UPDATE_RELIGION_FAIL = "UPDATE_RELIGION_FAIL"
export const ADD_NEW_RELIGION = "ADD_NEW_RELIGION"
export const ADD_RELIGION_SUCCESS = "ADD_RELIGION_SUCCESS"
export const ADD_RELIGION_FAIL = "ADD_RELIGION_FAIL"